import parsePhoneNumberFromString from 'libphonenumber-js';

export const formatMobileNumber = (mobileNumber: string): string => {
  const parsed = parsePhoneNumberFromString(mobileNumber, 'SE');
  return parsed?.formatNational() ?? mobileNumber;
};

export const formatDate = (value: string) => new Date(value).toLocaleDateString('sv-SE');
